"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellRef = void 0;
exports.rows = rows;
exports.cells = cells;
exports.tableToGrid = tableToGrid;
exports.findCell = findCell;
exports.textTest = textTest;
exports.regexpTest = regexpTest;
exports.extractSheetIds = extractSheetIds;
exports.extractTables = extractTables;
exports.getTrimmed = getTrimmed;
const grid = require("./grid");
function rows(table) {
    return table.querySelectorAll('tr');
}
function cells(row) {
    return row.querySelectorAll('td');
}
function tableToGrid(table) {
    const result = [];
    for (const tr of rows(table)) {
        const row = [];
        for (const cell of tr.querySelectorAll('td')) {
            for (let i = 1; i <= cell.colSpan; i++) {
                row.push(cell);
            }
        }
        if (row.length > 0) {
            result.push(row);
        }
    }
    return result;
}
exports.CellRef = grid.CellRef;
// Searches for the next cell where `pred` evaluates to true.
function findCell(g, test, from) {
    return grid.findCell(g, test, from);
}
function textTest(text) {
    return (c, ref) => {
        return c.textContent == text;
    };
}
function regexpTest(regexp) {
    return (c, ref) => {
        return c.textContent?.match(regexp) != null;
    };
}
function extractSheetIds(document) {
    const menu = document.querySelector('#sheet-menu');
    if (!menu?.children) {
        throw 'No sheets found';
    }
    const ids = [];
    for (const child of menu?.children) {
        if (child.id.startsWith('sheet-button-')) {
            const parts = child.id.split('-');
            ids.push(parts[2]);
        }
    }
    return ids;
}
function extractTables(document) {
    return document.querySelectorAll('table');
}
function getTrimmed(cell) {
    const text = cell.textContent;
    if (text == null) {
        return '';
    }
    return text.trim().replace(/\u200B/g, '');
}
